module.exports = __webpack_public_path__ + "static/media/video-production.ac8d87e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/video-production.svg
// module id = 324
// module chunks = 0